import { AuthConfig } from 'angular-oauth2-oidc';
export const FsxB2CDocumentDiscoveryURL = 'https://fsagencymdoahdev.b2clogin.com/fsagencymdoahdev.onmicrosoft.com/B2C_1A_DEMO_EMAIL_SIGNIN/v2.0/.well-known/openid-configuration';
const FsxB2CClientId = '5c6b6ce0-3e56-433e-b28b-d7492bdca113';
const FsxB2CScopes = 'openid profile email offline_access https://fsagencymdoahdev.onmicrosoft.com/362d0313-4f09-415c-839f-e87696db79d6/access_as_user';
const FsxB2CIssuer = 'https://fsagencymdoahdev.b2clogin.com/009ba2ae-7b8a-44bc-9ff0-485bb16475ee/v2.0/'
const FsxB2CLoginUrl = 'https://fsagencymdoahdev.b2clogin.com/fsagencymdoahdev.onmicrosoft.com/B2C_1A_DEMO_EMAIL_SIGNIN/oauth2/v2.0/authorize';
const FsxB2CLogoutUrl = 'https://fsagencymdoahdev.b2clogin.com/fsagencymdoahdev.onmicrosoft.com/signout/B2C_1A_DEMO_EMAIL_SIGNIN'

export const authConfig: AuthConfig = {
  // ToDo: Need to store these magic strings in environment variables.
  issuer: FsxB2CIssuer,
  loginUrl: FsxB2CLoginUrl,
  logoutUrl: FsxB2CLogoutUrl,
  // ToDo: I believe we need to register all possible returnUri's in the Azure AD B2C App Registration
  redirectUri: window.location.origin + '/index.html',
  clientId: FsxB2CClientId,
  responseType: 'code',
  strictDiscoveryDocumentValidation: false,
  scope: FsxB2CScopes,
  showDebugInformation: false,
  skipIssuerCheck: false,
  // timeoutFactor: .01
}
